import React from 'react';
import { Modal } from 'antd'
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect
} from "react-router-dom";
import { InfoCircleOutlined, CloseOutlined } from '@ant-design/icons'
import { ApolloProvider } from '@apollo/react-hooks';

import client from './ApolloClient'
import Header from './component/Header'
import Login from './component/Login'

import Renderer from './pages/DownloadPage/components/index'

import {
  DownloadPage,
  AdminPage,
  PageNotFound
} from './pages'
import {
  checkIfLoggedIn,
  clearLocalStorage
} from './functions'

import './App.scss'

class App extends React.Component {
  constructor(props) {
    super(props)
  
    this.state={
      open_login_modal: false,
      show_login_indicator: false
    }

    this.loginErrorDisplayRef = React.createRef()
  }

  componentDidMount() {
    if(checkIfLoggedIn()) {
      this.loggedIndicatorSetter(true)
    }
  }

  onLogin = () => {
    this.setState({
      open_login_modal: true
    })
  }

  onLogout = () => {
    clearLocalStorage()
    window.location.reload(true);
  }

  loginVisibilitySetter = (value) => {
    this.setState({
      open_login_modal: value
    })
  }

  loggedIndicatorSetter = (value) => {
    this.setState({
      show_login_indicator: value
    })
  }

  render() { 

    const PrivateRoute = (props) => {
      if(checkIfLoggedIn()){
        return (
          <Route
            {...props}
          /> 
        )
      } else {
        return <Redirect to='/'/>
      }
    }

    return (
      <ApolloProvider client={client}>
        <div className="App">
          <Router>
            <Modal
              visible={this.state.open_login_modal}
              closable={false}
              footer={null}
              wrapClassName="login__modal"
              width={400}
              onCancel={e => {
                this.setState({
                  open_login_modal: false
                })
              }}
              afterClose={e => {
                this.loginErrorDisplayRef.current.clearError()
              }}
            >
              <Login
                loginVisibilitySetter={this.loginVisibilitySetter}
                ref={this.loginErrorDisplayRef}
              />
            </Modal>
            <Header
              onLogin={this.onLogin}
              onLogout={this.onLogout}
              isLoggedIn={checkIfLoggedIn()}
            />
            <div className="logged-in__indicator-div"
              style={{
                display: this.state.show_login_indicator? null : 'none'
              }}
            >
              <InfoCircleOutlined className="logged-in__indicator--icon"/>You are logged in as Administrator
              <span className="logged-in__indicator--close"
                onClick={e => this.setState({ show_login_indicator: false })}
              ><CloseOutlined /></span>
            </div>
            <Switch>
              <Route path="/" exact component={DownloadPage}/>
              <PrivateRoute path="/admin" exact component={AdminPage}/>
              {/* <Route path="/pdf" exact render={() => <Renderer/>}/> */}
              <Route render={() =>  <div className="page-not-found__container"><PageNotFound/></div>}/>
            </Switch>
          </Router>    
        </div>
      </ApolloProvider>
    )
  }
  
}

export default App
